import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../services/supabaseClient';
import { BidangUsahaList, DokumenLegalitas } from '../../components/RegistrationInfo';

const VerifikasiPendaftaran = () => {
  const { session, userRole } = useAuth();
  const [registrations, setRegistrations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [processingId, setProcessingId] = useState(null);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('registrations')
        .select('*, master_provinces(name), master_cities(name), registration_business_types(master_business_types(name, sort_order))')
        .eq('status', 'Menunggu verifikasi')
        .order('created_at', { ascending: false });

      if (error) throw error;
      setRegistrations(data || []);
    } catch (error) {
      console.error('Error fetching registrations:', error);
      alert('Gagal mengambil data pendaftar.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (session) fetchData();
  }, [session]);

  if (userRole !== 'admin_provinsi') {
    return <Navigate to="/admin" replace />;
  }

  const handleApprove = async (id) => {
    if (!window.confirm('Yakin ingin menyetujui pendaftar ini ke tingkat Nasional?')) return;

    try {
      setProcessingId(id);
      const { error } = await supabase
        .from('registrations')
        .update({ status: 'Menunggu verifikasi nasional' })
        .eq('id', id);

      if (error) throw error;
      setRegistrations((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error('Error approving:', error);
      alert('Terjadi kesalahan saat menyetujui data.');
    } finally {
      setProcessingId(null);
    }
  };

  const handleReject = async (id) => {
    const notes = window.prompt('Masukkan catatan perbaikan untuk pendaftar (Wajib):');

    if (notes === null) return;
    if (notes.trim() === '') {
      alert('Catatan perbaikan tidak boleh kosong.');
      return;
    }

    try {
      setProcessingId(id);
      const { error } = await supabase
        .from('registrations')
        .update({
          status: 'Perlu perbaikan',
          notes: notes
        })
        .eq('id', id);

      if (error) throw error;
      setRegistrations((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error('Error returning for revision:', error);
      alert('Terjadi kesalahan saat mengembalikan data.');
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Verifikasi Pendaftaran (Tingkat Provinsi)</h1>
      <p className="text-gray-600 mb-6">Daftar pesantren yang menunggu tinjauan administratif di wilayah Anda.</p>

      <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-200">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Identitas Pesantren</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Lokasi</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bidang Usaha</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Badan Hukum dan Dokumen</th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Aksi</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {isLoading ? (
                <tr>
                  <td colSpan="5" className="px-6 py-12 text-center text-gray-500">Memuat data...</td>
                </tr>
              ) : registrations.length === 0 ? (
                <tr>
                  <td colSpan="5" className="px-6 py-12 text-center text-gray-500">Tidak ada pendaftar yang menunggu verifikasi.</td>
                </tr>
              ) : (
                registrations.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div className="text-sm font-semibold text-gray-900">{item.pesantren_name}</div>
                      <div className="text-sm text-gray-500">Penanggung Jawab Pesantren: {item.pic_hebitren_name}</div>
                      <div className="text-sm text-gray-500">{item.contact_number}</div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm text-gray-900">{item.master_cities?.name || '-'}</div>
                      <div className="text-sm text-gray-500">{item.master_provinces?.name || '-'}</div>
                    </td>
                    <td className="px-6 py-4">
                      <BidangUsahaList item={item} />
                    </td>
                    <td className="px-6 py-4">
                      <DokumenLegalitas item={item} />
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-center space-y-2 sm:space-y-0 sm:space-x-2 flex flex-col sm:flex-row justify-center">
                      <button
                        onClick={() => handleApprove(item.id)}
                        disabled={processingId === item.id}
                        className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 disabled:opacity-50 transition-colors"
                      >
                        {processingId === item.id ? 'Memproses...' : 'Setujui ke Pusat'}
                      </button>
                      <button
                        onClick={() => handleReject(item.id)}
                        disabled={processingId === item.id}
                        className="bg-orange-500 text-white px-3 py-1 rounded hover:bg-orange-600 disabled:opacity-50 transition-colors"
                      >
                        Kembalikan
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VerifikasiPendaftaran;